import { Link } from "react-router-dom";
import Details from "../../Shared/ListingDetails/Details";
import Button from "./Button";

const ListingCard = ({ title, imageUrls }) => {
  return (
    <div className="box-border grid grid-cols-5 overflow-hidden border border-lightGray">
      <picture className="aspect-square">
        <img
          src={imageUrls[0] || "https://via.placeholder.com/150"}
          alt=""
          className="aspect-square w-full"
        />
      </picture>

      <div className="col-span-3 flex flex-col items-start justify-start px-8 pt-8 pb-4">
        <Link to="/auctionlisting">
          <h3 className="font-pop text-xl font-bold">
            {title || "Buz Plumbing"}
          </h3>
        </Link>
        <p className="mt-2 mb-4 flex items-end gap-1 font-pop text-xs font-normal text-cardSecondaryColor">
          We specialize in all plumbing
        </p>
        <Details />
      </div>
      <Button />
    </div>
  );
};

export default ListingCard;
